import { Component, inject, Input, OnInit } from '@angular/core';
import { InspectorGridService } from '../../services/inspectors-grid/inspectors-grid.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sopra-roles',
  templateUrl: './sopra-roles.component.html',
  styleUrl: './sopra-roles.component.scss',
})
export class SopraRolesComponent implements OnInit {
  newRole: any = null;
  showChooseRole: boolean = false;

  @Input() inspectorRoles: any[] = [];
  @Input() inspectorId: number | null = null;

  inspectorGridService = inject(InspectorGridService);
  dialog = inject(MatDialog);
  saveDialogRef: MatDialogRef<AlertBoxComponent>;

  groups: any[] = [];
  allGroups: any[] = [];

  ngOnInit(): void {
    this.getUserGroups();
  }

  enableChooseRole() {
    this.showChooseRole = true;
  }

  getUserGroups() {
    this.inspectorGridService.getUserGroups().subscribe({
      next: (res) => {
        this.allGroups = res;
        this.calculateAvailableGroups();
      },
    });
  }
  calculateAvailableGroups() {
    this.groups = this.allGroups.filter(
      (group) => !this.inspectorRoles.some((role) => role?.role?.id === group.id)
    );
  }

  deleteRole(id) {
    const inspectorRolesIds = this.inspectorRoles
      .filter((role) => role?.role?.id !== id)
      .map((role) => role?.role?.id);
    if (inspectorRolesIds.length >= 1) {
      const data = { groups: [...inspectorRolesIds] };
      this.updateUserRoles(data);
    } else {
      this.showAlertBox('يجب أن يكون للمستخدم دور واحد على الأقل', false);
    }
  }

  showAlertBox(message: string, isSuccess: boolean) {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: isSuccess,
        message: message,
        button: 'موافق',
      },
    });
  }

  saveNewRole() {
    const inspectorRolesIds = this.inspectorRoles.map((role) => role?.role?.id);
    const data = { groups: [...inspectorRolesIds, this.newRole] };
    this.updateUserRoles(data);
  }

  updateUserRoles(data) {
    this.inspectorGridService
      .updateInspectorsData(this.inspectorId, data)
      .subscribe({
        next: (res) => {
          this.inspectorRoles = res.user_roles;
          this.calculateAvailableGroups();
          this.newRole = null;
          this.showChooseRole = false;
        },
      });
  }
}
